module.exports = __webpack_public_path__ + "media/images/konintodoke/diagnosis/background-a0935fed6aaf48424f51d8aa417080fa.jpg";